import { render } from "./CreateReport.vue?vue&type=template&id=ee8f4e1c&scoped=true"
import script from "./CreateReport.vue?vue&type=script&lang=js"
export * from "./CreateReport.vue?vue&type=script&lang=js"

import "./CreateReport.vue?vue&type=style&index=0&id=ee8f4e1c&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee8f4e1c"]])

export default __exports__